import { render } from "./TextareaTypeComponent.vue?vue&type=template&id=0af838ea&scoped=true"
import script from "./TextareaTypeComponent.vue?vue&type=script&lang=js"
export * from "./TextareaTypeComponent.vue?vue&type=script&lang=js"

import "./TextareaTypeComponent.vue?vue&type=style&index=0&id=0af838ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af838ea"]])

export default __exports__